import { Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import {
  QSetReviewTaskCreationFormModal,
  type QSetReviewTaskCreationFormModalProps,
} from '../qset-review-task-creation-form-modal';

type QSetReviewTaskCreationButtonProps = ButtonProps &
  Pick<QSetReviewTaskCreationFormModalProps, 'examCourse'>;

export default function QSetReviewTaskCreationButton(
  props: Readonly<QSetReviewTaskCreationButtonProps>,
) {
  const { examCourse, ...buttonProps } = props;
  const [isTaskCreationModalOpen, taskCreationModalHandlers] = useDisclosure();
  const { open: openTaskCreationModal, close: closeTaskCreationModal } = taskCreationModalHandlers;

  const handleClickCreateTask = () => {
    openTaskCreationModal();
  };

  const handleCloseModal = () => {
    closeTaskCreationModal();
  };

  return (
    <>
      <Button {...buttonProps} onClick={handleClickCreateTask} />
      {isTaskCreationModalOpen ? (
        <QSetReviewTaskCreationFormModal
          isOpen={isTaskCreationModalOpen}
          onClose={handleCloseModal}
          examCourse={examCourse}
        />
      ) : null}
    </>
  );
}
